module.exports = __webpack_public_path__ + "static/room1-4-eb5192bd345a53991d510e116de9579b.jpg";